export default __webpack_public_path__ + "static/media/avatar.dd171c71.png";